export default __webpack_public_path__ + "static/studio-slider-3-2f4d277f28264f951c5b216478b00155.png";